import { AppState } from "../../../redux-configuration/AppState";

export const cancelOrderLoadingSelector = (appState: AppState): boolean => appState.clickCollect.cancelOrder.loading
export const cancelOrderErrorSelector = (appState: AppState): string | undefined  => appState.clickCollect.cancelOrder.error
export const cancelOrderSuccessSelector = (appState: AppState): boolean  => appState.clickCollect.cancelOrder.success
